import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import { baselightTheme } from "utils/theme/defaultColors";
import { apiPlugin, storyblokInit } from "@storyblok/react";
import Article from "storyblok/components/Article";
import "i18n";
import "react-toastify/dist/ReactToastify.css";
import Hero from "storyblok/components/Hero";
import Page from "storyblok/components/Page";
import GridContainer from "storyblok/components/Grid";
import Announcement from "storyblok/components/Announcement";
import NavigationList from "storyblok/components/NavigationList";
import FeaturedArticlesList from "storyblok/components/FeaturedArticlesList";
import ListComponent from "storyblok/components/List";
import { HelmetProvider } from "react-helmet-async";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

storyblokInit({
  accessToken: process.env.REACT_APP_STORYBLOK_API_TOKEN,
  use: [apiPlugin],
  components: {
    page: Page,
    hero: Hero,
    article: Article,
    grid: GridContainer,
    list: ListComponent,
    announcement: Announcement,
    navigation: NavigationList,
    featured_articles: FeaturedArticlesList,
  },
  apiOptions: { region: "eu" },
});

root.render(
  // <React.StrictMode>
  <BrowserRouter>
    <ThemeProvider theme={baselightTheme}>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </ThemeProvider>
  </BrowserRouter>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
